<template>
  <div>
    <modal :size="'modal-large'"
           :close-strict="true"
           @close="$emit('close')"
    >
      <div slot="header">
        <h4>Leave rating</h4>
      </div>
      <div class="modal-body-scroll" slot="body">
        <div class="row review-job-info">
          <div class="col-md-12 text-center mb-3">
            <p>
              How was your experience with {{ job.customer.first_name }} {{ job.customer.last_name }}?
            </p>
            <p>
              We won’t share your feedback with the customer until they leave a feedback too.
            </p>
            <div class="d-flex align-content-center justify-content-center">
              <star-rating class="pt-3 rate-wrapper"
                           @rating-selected="setRating($event, 'rating')"
                           v-model="rating"
                           :read-only="disabled"
                           :star-size="30"
                           :show-rating="false"
                           :rounded-corners="true"
                           :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]"
              />
              <error-field :errors="errors" field="value" />
            </div>
          </div>
          <div class="col-md-12 text-center review-container mt-4">
            <div class="select-wrap">
              <div class="d-flex justify-content-between comment-heading">
                <label>Customer review</label>
                <span class="review-body-length" v-if="remainingCount > 0">min {{ remainingCount }}</span>
              </div>
              <textarea class="form-control w-100 border-0 bg-transparent review-comment"
                        @keyup="countdown"
                        v-model="body"
                        minlength="100"
                        :disabled="disabled"
              />
            </div>
            <error-field :errors="errors" field="rating" />
            <h3 class="rating-error" v-if="ratingError">{{ ratingError }}</h3>
            <div class="d-flex align-items-center mt-3">
              <button class="btn btn-primary modal-done" @click="confirmReviewInfo" :disabled="remainingCount > 0 || loading">
                Share review
                <div class="ld ld-ball ld-flip" v-if="loading" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" />
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Modal from '../../Modal';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  components: {
    Modal,
    ErrorField,
  },
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    ratingError: null,
    rating: null,
    body: '',
    minCount: 100,
    remainingCount: 100,
    loading: false,
    disabled: false,
    errors: new Errors(),
  }),
  mounted() {
    if (this.job.customer_rating) {
      this.setRating(this.job.customer_rating.rating, 'rating');
      this.body = this.job.customer_rating.body;
      this.disabled = true;
    }
  },
  methods: {
    countdown() {
      this.remainingCount = this.minCount - this.body.length;
    },
    confirmReviewInfo() {
      this.loading = true;
      axios
        .post(`customers/${this.job.customer_id}/ratings`, {
          job_id: this.job.id,
          body: this.body,
          rating: this.rating,
        })
        .then(() => {
          this.job.has_ratings = true;
          this.$emit('close');
          this.$emit('getJob');
          this.loading = false;
          toastr.success('Customer successfully rated');
        })
        .catch(err => {
          this.loading = false;
          this.errors.record(err.response.data.error);
        });
    },
    setRating(rating, type) {
      this[type] = rating;
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

span,
h2,
h4,
h6,
p {
  font-family: 'Roboto', sans-serif !important;
}

.vue-star-rating {
  &.rate-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;

    & > div {
      display: flex;
      width: 340px;
      justify-content: space-between;

      & > span {
        min-width: 30px;
      }
    }
  }
}

.modal-body-scroll {
  height: 80vh;
}

.modal-done {
  min-width: 100% !important;
}

.star-label {
  line-height: 3;
}
.rating-error {
  color: red;
  margin-bottom: 10px;
}
.comment-heading {
  padding: 4px 4px 4px 0;
  & > span {
    font-size: 11px;
    color: #808d98;
  }
}
.review-comment {
  height: 250px !important;
}
.review-container {
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/modals/CustomerReviewModal.vue